const shareYourOpinionForm = document.getElementById( 'gform_6' )

/**
 * Add a reset button to the wrapper.
 *
 * @param {HTMLElement} confirmationWrapper The confirmation wrapper element.
 */
const addResetButton = ( confirmationWrapper ) => {
	const resetButton = document.createElement( 'a' )
	resetButton.href = '/your-opinion-matters#gform_6'
	resetButton.classList.add( 'site-link', 'flex', 'pointer', 'items-center', 'justify-center', 'ttu', 'tracked', 'orange-1', 'fw6' )
	resetButton.textContent = 'Reset'
	const buttonIcon = document.createElement( 'span' )
	buttonIcon.classList.add( 'mw2', 'ml3' )
	const icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.015 24.588"><path d="M12.354,24.588a.885.885,0,0,1-.626-1.51L22.512,12.294,11.728,1.511A.885.885,0,1,1,12.98.259L25.015,12.294,12.98,24.329A.881.881,0,0,1,12.354,24.588Z" fill="currentColor"></path><path d="M6.787,19.021a.885.885,0,0,1-.626-1.511l5.216-5.216L6.161,7.078A.885.885,0,0,1,7.412,5.827l6.468,6.467L7.412,18.762A.885.885,0,0,1,6.787,19.021Z" fill="currentColor"></path><circle cx="1.298" cy="12.294" r="1.298" fill="currentColor"></circle></svg>'
	buttonIcon.innerHTML = icon
	resetButton.appendChild( buttonIcon )
	confirmationWrapper.appendChild( resetButton )
}

/**
 * Handle the displaying of the results from the database.
 *
 * @param {Object} data The entries from the database.
 */
const displayResults = ( data ) => {

	const confirmationWrapper = document.getElementById( 'gform_confirmation_wrapper_6' )

	// Clear the HTML area.
	confirmationWrapper.innerHTML = ''

	if ( data.results ) {

		const header = document.createElement( 'h2' )
		header.classList.add( 'mv0', 'pink', 'w-100', 'f4', 'tc', 'fw4', 'pt4' )
		header.textContent = 'Here\'s what the community said:'

		const resultsList = document.createElement( 'ul' )
		confirmationWrapper.appendChild( header )
		confirmationWrapper.appendChild( resultsList )
		resultsList.classList.add( 'list', 'mw7', 'center', 'flex', 'flex-wrap', 'justify-center', 'ma0', 'pv0', 'ph3', 'tc', 'lh-copy' )

		data.results.forEach( result => {
			const resultListItem = document.createElement( 'li' )
			resultListItem.classList.add( 'flex', 'flex-wrap', 'flex-column', 'items-center', 'justify-center', 'w-50', 'w-50-m', 'w-third-l', 'pa3' )
			const resultPercentage = document.createElement( 'p' )
			resultPercentage.classList.add( 'orange-2', 'mb0' )
			resultPercentage.innerHTML = `<span class="f-6">${result.percentage}</span><span class="f1">%</span>`
			const resultValue = document.createElement( 'p' )
			resultValue.classList.add( 'flex-auto' )
			resultValue.style.maxWidth = '11rem'
			resultValue.textContent = result.value
			resultListItem.appendChild( resultPercentage )
			resultListItem.appendChild( resultValue )
			resultsList.appendChild( resultListItem )
		} )

		confirmationWrapper.style.opacity = 1
		addResetButton( confirmationWrapper )
		AOS.refresh()

	}
}

/**
 * Get the form entries from the database.
 */
const handleFormDisplay = () => {
	fetch( '/wp-content/themes/Volum8WP/assets/functions/inc/Get_GF_Entries.php', {
		body: new URLSearchParams( [...( new FormData( shareYourOpinionForm ) ) ] ),
		method: 'POST'
	} )
		.then( response => response.json() )
		.then( data => displayResults( data ) )
		// eslint-disable-next-line no-console
		.catch( error => console.error( error ) )
}

/**
 * Add the site link icon to the Gravity Forms button.
 */
const addButtonIcon = () => {
	const submitButton = document.querySelector( '[id^="gform_submit_button"]' )
	submitButton.classList.add( 'site-link' )
	const buttonIcon = document.createElement( 'span' )
	buttonIcon.classList.add( 'mw2' )
	const icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.015 24.588"><path d="M12.354,24.588a.885.885,0,0,1-.626-1.51L22.512,12.294,11.728,1.511A.885.885,0,1,1,12.98.259L25.015,12.294,12.98,24.329A.881.881,0,0,1,12.354,24.588Z" fill="currentColor"></path><path d="M6.787,19.021a.885.885,0,0,1-.626-1.511l5.216-5.216L6.161,7.078A.885.885,0,0,1,7.412,5.827l6.468,6.467L7.412,18.762A.885.885,0,0,1,6.787,19.021Z" fill="currentColor"></path><circle cx="1.298" cy="12.294" r="1.298" fill="currentColor"></circle></svg>'
	buttonIcon.innerHTML = icon
	submitButton.appendChild( buttonIcon )
}

if ( shareYourOpinionForm ) {
	addButtonIcon()
	jQuery( document ).on( 'gform_confirmation_loaded', () => {
		handleFormDisplay( shareYourOpinionForm )
	} )
}
